import { NumberField, Text } from "@simplybusiness/mobius";
import type { ReactNode } from "react";
import type { QuestionComponentProps } from "../../types";

export type Range = {
  min?: number;
  max?: number;
};

export const getRangeProps = (value?: Range) => {
  return {
    minValue: value?.min || undefined,
    maxValue: value?.max || undefined,
  };
};

export const NumberQuestion = ({
  questionFieldProps,
  config,
}: QuestionComponentProps) => {
  const {
    value,
    validation,
    readOnly,
    onChange,
    questionLabelProps,
    helpInfo,
    ...otherProps
  } = questionFieldProps;
  const { wholeNumber = false, prefix } = config ?? {};
  const rangeProps = getRangeProps(validation?.value as Range);

  if (Array.isArray(value)) {
    throw new TypeError("NumberQuestion: defaultValue must be a number");
  }

  const parsedDefaultValue =
    value == null || value === "" ? undefined : Number(value);

  const realPrefix =
    prefix != null ? <Text>{prefix as ReactNode}</Text> : undefined;

  // FIXME: Change NumberField to use value prop instead of defaultValue in mobius
  return (
    <NumberField
      {...otherProps}
      step={wholeNumber ? 1 : 0.01}
      defaultValue={parsedDefaultValue}
      prefixInside={realPrefix}
      {...rangeProps}
      isReadOnly={!!readOnly}
    />
  );
};
